import React from "react";
import { getContrastTextColor } from "../../helpers/color-helper";
import { Asset } from "../../types/public-types";
import styles from "./asset-list-table.module.css";

export const AssetListTableDefault: React.FC<{
	rowHeight: number;
	rowWidth: number;
	fontFamily: string;
	fontSize: string;
	assets: Asset[];
	selectedAssetId: string;
	setSelectedAsset: (assetId: string) => void;
}> = ({ rowHeight, rowWidth, fontFamily, fontSize, assets }) => {
	const headerX: number = 0;
	const cellPadding: number = 0.1;
	return (
		<g>
			<defs>
				{assets.map((t) =>
					t.colorGradientEnd ? (
						<linearGradient
							key={`${t.id}grad`}
							id={`asset-grad-${t.id}`}
							x1="0%"
							y1="0%"
							x2="100%"
							y2="100%"
						>
							<stop offset="0%" stopColor={t.color} />
							<stop offset="100%" stopColor={t.colorGradientEnd} />
						</linearGradient>
					) : null,
				)}
			</defs>
			<rect
				x={headerX}
				y={0}
				width={rowWidth}
				height={rowHeight * assets.length}
				className={styles.graphicWrapper}
			/>
			{assets.map((t, index) => {
				return (
					<g key={`${t.id}g`}>
						<rect
							key={`${t.id}row`}
							x={headerX}
							y={index * rowHeight}
							width={rowWidth}
							height={rowHeight}
							className={
								index % 2 === 0 ? styles.graphicRow : styles.graphicRowAlt
							}
						></rect>
						<rect
							key={`${t.id}cell`}
							x={headerX + cellPadding * rowWidth}
							y={index * rowHeight + cellPadding * rowHeight}
							width={rowWidth * (1 - cellPadding * 2)}
							height={rowHeight * (1 - cellPadding * 2)}
							rx={6}
							ry={6}
							className={styles.graphicCell}
							style={{
								fill: t.colorGradientEnd ? `url(#asset-grad-${t.id})` : t.color,
							}}
						></rect>
						{/* foreignObject lets the label wrap across lines (SVG <text>
						    can't) and stay centered in the cell for long asset names. */}
						<foreignObject
							key={`${t.id}text`}
							x={headerX + cellPadding * rowWidth}
							y={index * rowHeight + cellPadding * rowHeight}
							width={rowWidth * (1 - cellPadding * 2)}
							height={rowHeight * (1 - cellPadding * 2)}
						>
							<div
								style={{
									width: "100%",
									height: "100%",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									textAlign: "center",
									padding: "0 8px",
									boxSizing: "border-box",
									fontFamily: fontFamily,
									fontSize: 20,
									lineHeight: 1.15,
									color: getContrastTextColor(t.color),
									overflowWrap: "anywhere",
								}}
							>
								{t.name}
							</div>
						</foreignObject>
					</g>
				);
			})}
		</g>
	);
};
